module.exports = __webpack_public_path__ + "img/06.ffc86714.png";